import { handleActions, createAction } from 'redux-actions';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';

// Actions
export const actions = mapActions([
    'FETCH',
    'FETCH_SUCCESS',
    'RESET_TO_INITIAL_STATE'
], 'REALVALUE');


// Action Creators
export const fetchRealValue = createAction(actions.FETCH, params => params);
export const realValueFetched = createAction(actions.FETCH_SUCCESS, data => data);
export const resetRealValueInitialState = createAction(actions.RESET_TO_INITIAL_STATE);

// Reducers
const initialState = {
    data: null,
    hasData: null // defaulting to null to indicate we are fetching data and don't know if we have data or not.
};

export default handleActions({

    [actions.FETCH_SUCCESS]: (state, action) => {
        const hasData = action.payload.params.hasData;

        if (hasData) {
            const updatedData = {
                data: { $set: action.payload.data },
                hasData: { $set: hasData }
            };
            return update(state, updatedData);
        }

        const updatedData = {
            hasData: { $set: hasData }
        };
        return update(state, updatedData);
    },

    [actions.RESET_TO_INITIAL_STATE]: state => update(state, { $set: initialState })

}, initialState);



// WEBPACK FOOTER //
// ./src/services/realValue/duck.js